import { render, staticRenderFns } from "./AccordionListItem.vue?vue&type=template&id=188b24d2"
import script from "./AccordionListItem.vue?vue&type=script&lang=js"
export * from "./AccordionListItem.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports